export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || "/api";

const ABSOLUTE_OR_PROTOCOL_RELATIVE_URL = /^(?:[a-z][a-z\d+.-]*:|\/\/)/i;

/**
 * Resolve an API-provided download URL against the configured API host.
 *
 * Proxy download URLs are returned as root-relative paths (for example
 * `/api/Document/S3Download?...`). When the UI and API use different origins,
 * opening that path directly would send it to the UI server instead of the API.
 * Existing absolute and non-HTTP URLs are intentionally preserved.
 */
export function resolveDownloadUrl(downloadUrl: string, apiBaseUrl: string = API_BASE_URL): string {
  const value = downloadUrl.trim();
  if (!value || ABSOLUTE_OR_PROTOCOL_RELATIVE_URL.test(value)) {
    return value;
  }

  const base = apiBaseUrl.trim() || "/api";
  if (/^https?:\/\//i.test(base)) {
    const apiUrl = new URL(base);
    const resolutionBase = value.startsWith("/") ? apiUrl.origin : `${base.replace(/\/+$/, "")}/`;
    return new URL(value, resolutionBase).toString();
  }

  if (value.startsWith("/")) {
    return value;
  }

  return `${base.replace(/\/+$/, "")}/${value.replace(/^\/+/, "")}`;
}
